<template>
  <div class="layout">
    <Toolbar class="flex-row p-1 m-1-b gap-1 align-center">
      <template #end>
        <Select
          :modelValue="props.options.direction || 'column'"
          @update:modelValue="emits('update', { direction: $event })"
          :options="[
            { label: 'Row', value: 'row' },
            { label: 'Column', value: 'column' },
          ]"
          option-label="label"
          option-value="value"
        />
        <Select
          :modelValue="props.options.justify"
          @update:modelValue="emits('update', { justify: $event })"
          :options="[
            { label: 'Justify Left', value: 'flex-start' },
            { label: 'Justify Center', value: 'center' },
            { label: 'Justify Right', value: 'flex-end' },
            { label: 'Justify Stretch', value: 'stretch' },
          ]"
          option-label="label"
          option-value="value"
        />
        <Select
          :modelValue="props.options.align"
          @update:modelValue="emits('update', { align: $event })"
          :options="[
            { label: 'Align Left', value: 'flex-start' },
            { label: 'Align Center', value: 'center' },
            { label: 'Align Right', value: 'flex-end' },
            { label: 'Align Stretch', value: 'stretch' },
          ]"
          option-label="label"
          option-value="value"
        />
      </template>
    </Toolbar>
    <LayoutBuilder
      :class="{
        'direction-row': props.options.direction === 'row',
        'direction-column': props.options.direction === 'column',
        'justify-left': props.options.justify === 'flex-start',
        'justify-center': props.options.justify === 'center',
        'justify-right': props.options.justify === 'flex-end',
        'justify-stretch': props.options.justify === 'stretch',
        'align-left': props.options.align === 'flex-start',
        'align-center': props.options.align === 'center',
        'align-right': props.options.align === 'flex-end',
        'align-stretch': props.options.align === 'stretch',
      }"
      :layout="layout"
      @update:layout="emits('update', { layout: $event })"
    />
  </div>
</template>

<script setup lang="ts">
import Select from "primevue/dropdown";
import Toolbar from "primevue/toolbar";
import { computed } from "vue";
import LayoutBuilder from "./LayoutBuilder.vue";

const props = defineProps<{
  options: any;
}>();
const emits = defineEmits(["update"]);
const layout = computed(() => {
  return props.options.layout || [];
});
</script>

<style scoped>
.direction-row :deep(.editing) {
  display: flex;
  flex-direction: row;
}
.justify-left :deep(.editing) {
  justify-content: flex-start;
}
.justify-right :deep(.editing) {
  justify-content: flex-end;
}
.justify-center :deep(.editing) {
  justify-content: center;
}
.justify-stretch :deep(.editing) {
  justify-content: stretch;
  & > * {
    flex: 1 1 auto;
  }
}
.align-left :deep(.editing) {
  align-items: flex-start;
}
.align-right :deep(.editing) {
  align-items: flex-end;
}
.align-center :deep(.editing) {
  align-items: center;
}
.align-stretch :deep(.editing) {
  align-items: stretch;
  & > * {
    flex: 1 1 auto;
  }
}
</style>
